module.exports = __webpack_public_path__ + "static/media/disappointed-angry-bored-sad-emoji-emoticon-svgrepo-com.a4a7f04f.svg";